import { TableState } from "primeng/api";
import { Observable, of } from "rxjs";


export abstract class TableSettingsService {
  abstract saveDebounceTimeInMs: number;
  abstract getSettings: (tableIdentifier: string) => Observable<TableState>;
  abstract saveSettings: (tableIdentifier: string, state: TableState) => Observable<boolean>;
}

export class LocalStorageTableSettingsService implements TableSettingsService {
  private prefix = 'avanoTableSettings.';
  saveDebounceTimeInMs: 100;
  getSettings: (tableIdentifier: string) => Observable<TableState> = (tableIdentifier) => {
    try {
      const tableState = localStorage.getItem(this.prefix + tableIdentifier);
      if (tableState) {
          return of(JSON.parse(tableState) as TableState);
      }
    } catch {
        console.log('LocalStorageTableSettingsService: Getting state from LocalStorage cannot be used, perhaps disabled in browser');
      }
    // loclStorage.getItem can throw an exception and JSON.parse too.
    // If one of both fails, just return an empty observable, because then
    // default table settings will be applied.
    return of(null);


  };
  saveSettings: (tableIdentifier: string, state: TableState) => Observable<boolean> = (identifier, newState) => {
    try {
      localStorage.setItem(this.prefix + identifier, JSON.stringify(newState));
    } catch {
      console.log('LocalStorageTableSettingsService: Saving state to LocalStorage did not worked, perhaps disabled in browser');
    }
    return of(true);
  };
}
